<script setup>
import { ref } from 'vue';
import Button from 'primevue/button';
import { storeToRefs } from "pinia";
import { useCriarQuestoesStore } from "@/store/criarQuestoes";
import { salvarQuestao } from '@/api/fetchQuestoes';
import { useGlobalToast } from '@/composables/useGlobalToast';
const { showToast } = useGlobalToast();
const store = useCriarQuestoesStore();
const { questoes, modeloQuestaoSelecionado } = storeToRefs(store);

import { copiarQuestaoParaAreaDeTransferencia } from '@/utils/copiarQuestaoParaAreaDeTransferencia';

const props = defineProps({
    index: Number,
    required: true
})


const copiarQuestao = (index) => {
    copiarQuestaoParaAreaDeTransferencia(questoes.value[index]);
    showToast({ detail: 'Questão copiada', life: 3000 })
}

function excluirQuestao(index) {
    questoes.value.splice(index, 1);
}

const salvandoQuestao = ref(false);
async function validarSalvarQuestao(index) {
    salvandoQuestao.value = true;
    const { data, error } = await salvarQuestao(questoes.value[index]);
    if (error) {
        showToast({ severity: "error", detail: error.message, life: 3000 });
        salvandoQuestao.value = false;
        return;
    }

    salvandoQuestao.value = false;
    questoes.value.splice(index, 1);
}


</script>

<template>
    <div class="flex flex-row gap-2">
        <Button v-tooltip.top="'Salvar questão'" icon="pi pi-save" severity="secondary" text rounded
            @click="validarSalvarQuestao(index)" :loading="salvandoQuestao" />

        <Button v-tooltip.top="'Copiar questão'" icon="pi pi-copy" severity="secondary" text rounded
            @click="copiarQuestao(index)" />

        <Button v-tooltip.top="'Excluir questão'" icon="pi pi-trash" severity="secondary" text rounded
            @click="excluirQuestao(index)" />

    </div>
</template>